import { usePermissions } from "@/hooks/use-permissions";
import { useLocalization } from "@/context/localization-context";
import { CatalogBoard } from "@/catalog/catalog-board";

/** The customer's recipes, ingredients and products (developer role only; the backend enforces the same). */
export default function CatalogPage() {
  const { isDeveloper } = usePermissions();
  const { t } = useLocalization();

  if (!isDeveloper) {
    return (
      <div className="p-4 lg:p-6">
        <div className="rounded-md border border-dashed p-6 text-sm text-muted-foreground">{t("catalog.forbidden")}</div>
      </div>
    );
  }

  return <CatalogBoard />;
}
